package com.fireavert.app

import com.fireavert.administration.admin_page.client.AdminPageRepositoryDataSource
import com.fireavert.administration.admin_page.client.AdminPageRepositoryDataSourceImpl
import com.fireavert.administration.admin_page.client.AdministrationPageRepository
import com.fireavert.administration.admin_page.client.AdministrationPageRepositoryImpl
import com.fireavert.administration.admin_page.client.presentation.AdministrationPageController
import com.fireavert.administration.admin_page.client.presentation.AdministrationPageInteractor
import com.fireavert.administration.admin_page.client.presentation.AdministrationPageScreen
import com.fireavert.administration.admin_page.client.presentation.AdministrationPageViewModel
import com.fireavert.administration.shared.interface_adaptors.RoutedAdminNavigator
import com.fireavert.administration.shared.logic.AdminNavigator
import com.fireavert.administration.shared.presentation.AdminRouter
import com.fireavert.administration.super_admin_tools_page.client.WirelessIdRepository
import com.fireavert.administration.super_admin_tools_page.client.WirelessIdRepositoryDataSourceImpl
import com.fireavert.administration.super_admin_tools_page.client.WirelessIdRepositoryImpl
import com.fireavert.administration.super_admin_tools_page.client.presentation.WirelessIdSectionController
import com.fireavert.administration.super_admin_tools_page.client.presentation.WirelessIdSectionInteractor
import com.fireavert.administration.super_admin_tools_page.client.presentation.WirelessIdSectionScreen
import com.fireavert.administration.super_admin_tools_page.client.presentation.WirelessIdSectionViewModel
import com.fireavert.administration.super_admin_tools_page.interface_adapters.WirelessIdRepositoryDataSource
import com.fireavert.administration.users_page.edit_user_dialog.client.UserDialogRepository
import com.fireavert.administration.users_page.edit_user_dialog.client.UserDialogRepositoryDataSource
import com.fireavert.administration.users_page.edit_user_dialog.client.UserDialogRepositoryDataSourceImpl
import com.fireavert.administration.users_page.edit_user_dialog.client.UserDialogRepositoryImpl
import com.fireavert.administration.users_page.edit_user_dialog.client.presentation.AddUserController
import com.fireavert.administration.users_page.edit_user_dialog.client.presentation.AddUserDialogScreen
import com.fireavert.administration.users_page.edit_user_dialog.client.presentation.AddUserInteractor
import com.fireavert.administration.users_page.edit_user_dialog.client.presentation.AddUserViewModel
import com.fireavert.administration.users_page.main_user_page.client.UserSectionRepository
import com.fireavert.administration.users_page.main_user_page.client.UserSectionRepositoryDataSource
import com.fireavert.administration.users_page.main_user_page.client.UserSectionRepositoryDataSourceImpl
import com.fireavert.administration.users_page.main_user_page.client.UserSectionRepositoryImpl
import com.fireavert.administration.users_page.main_user_page.client.presentation.UserSectionController
import com.fireavert.administration.users_page.main_user_page.client.presentation.UserSectionInteractor
import com.fireavert.administration.users_page.main_user_page.client.presentation.UserSectionScreen
import com.fireavert.administration.users_page.main_user_page.client.presentation.UserSectionViewModel
import com.fireavert.administration.users_page.user_info_page.client.UserInfoRepository
import com.fireavert.administration.users_page.user_info_page.client.UserInfoRepositoryDataSource
import com.fireavert.administration.users_page.user_info_page.client.UserInfoRepositoryDataSourceImpl
import com.fireavert.administration.users_page.user_info_page.client.UserInfoRepositoryImpl
import com.fireavert.administration.users_page.user_info_page.client.presentation.UserInfoController
import com.fireavert.administration.users_page.user_info_page.client.presentation.UserInfoInteractor
import com.fireavert.administration.users_page.user_info_page.client.presentation.UserInfoScreen
import com.fireavert.administration.users_page.user_info_page.client.presentation.UserInfoViewModel
import com.fireavert.administration.yardi_integration_page.presentation.YardiCommonDataScreen
import com.fireavert.administration.yardi_integration_page.presentation.YardiPropertyImportScreen
import com.fireavert.administration.yardi_integration_page.yardi_data_import_section.client.YardiPropertyImportInteractor
import com.fireavert.administration.yardi_integration_page.yardi_data_import_section.client.presentation.YardiPropertyImportController
import com.fireavert.administration.yardi_integration_page.yardi_data_import_section.client.presentation.YardiPropertyImportInteractorImpl
import com.fireavert.administration.yardi_integration_page.yardi_data_import_section.client.presentation.YardiPropertyImportViewModel
import com.fireavert.administration.yardi_integration_page.yardi_main_page.client.presentation.YardiCommonDataController
import com.fireavert.administration.yardi_integration_page.yardi_main_page.client.presentation.YardiCommonDataInteractor
import com.fireavert.administration.yardi_integration_page.yardi_main_page.client.presentation.YardiCommonDataViewModel
import com.fireavert.analytics.client.*
import com.fireavert.analytics.client.presentation.AppController
import com.fireavert.analytics.client.presentation.AppViewModel
import com.fireavert.auth.reset_password.client.ResetPasswordSender
import com.fireavert.auth.reset_password.client.ResetPasswordSenderImpl
import com.fireavert.auth.reset_password.client.ResetPasswordSenderSource
import com.fireavert.auth.reset_password.client.ResetPasswordUseCase
import com.fireavert.auth.reset_password.client.presentation.ResetPasswordController
import com.fireavert.auth.reset_password.client.presentation.ResetPasswordScreen
import com.fireavert.auth.reset_password.client.presentation.ResetPasswordViewModel
import com.fireavert.auth.shared.AuthNavigator
import com.fireavert.auth.shared.AuthRouter
import com.fireavert.auth.shared.GetUser
import com.fireavert.auth.shared.RoutedAuthNavigator
import com.fireavert.auth.user_authentication.client.*
import com.fireavert.auth.user_authentication.client.presentation.AuthController
import com.fireavert.auth.user_authentication.client.presentation.AuthScreen
import com.fireavert.auth.user_authentication.client.presentation.AuthViewModel
import com.fireavert.auth.user_authentication.client.presentation.PageAuthenticationController
import com.fireavert.buildings.client.ClientBuildingRepository
import com.fireavert.buildings.client.ClientBuildingRepositoryDataSource
import com.fireavert.buildings.client.ClientBuildingRepositoryDataSourceImpl
import com.fireavert.buildings.client.ClientBuildingRepositoryImpl
import com.fireavert.buildings.client.presentation.AddNewBuildingController
import com.fireavert.buildings.client.presentation.AddNewBuildingInteractor
import com.fireavert.buildings.client.presentation.AddNewBuildingScreen
import com.fireavert.buildings.client.presentation.AddNewBuildingViewModel
import com.fireavert.cache.client.AnalyticsService
import com.fireavert.cache.client.KeyValuePreferences
import com.fireavert.cache.client.Preferences
import com.fireavert.common.InMemoryCache
import com.fireavert.dashboard.client.ApiDashboardRepository
import com.fireavert.dashboard.client.ClientDashboardRepositoryDataSource
import com.fireavert.dashboard.client.DashboardRepository
import com.fireavert.dashboard.client.DashboardRepositoryDataSource
import com.fireavert.dashboard.client.presentation.DashboardController
import com.fireavert.dashboard.client.presentation.DashboardInteractor
import com.fireavert.dashboard.client.presentation.DashboardScreen
import com.fireavert.dashboard.client.presentation.DashboardViewModel
import com.fireavert.devices.client.ClientDeviceDataSource
import com.fireavert.devices.client.DeviceDataSource
import com.fireavert.devices.client.DevicesRouter
import com.fireavert.devices.server.ApiDeviceRepository
import com.fireavert.devices.server.DeviceRepository
import com.fireavert.events.active_events.client.ActiveEventsDataSource
import com.fireavert.events.active_events.client.ActiveEventsRepository
import com.fireavert.events.active_events.client.ApiActiveEventsRepository
import com.fireavert.events.active_events.client.ClientActiveEventsDataSource
import com.fireavert.events.active_events.client.presentation.ActiveEventsV2Interactor
import com.fireavert.events.active_events.client.presentation.ActiveEventsV2Screen
import com.fireavert.events.active_events.client.presentation.ActiveEventsV2ViewModel
import com.fireavert.events.dismiss_event.client.presentation.*
import com.fireavert.events.events_happening_now.client.presentation.*
import com.fireavert.events.mark_as_false_alarm.client.presentation.*
import com.fireavert.events.mark_as_test.client.presentation.*
import com.fireavert.events.reboot_devices.client.presentation.*
import com.fireavert.events.shared.client.*
import com.fireavert.events.shared.server.EventsRepository
import com.fireavert.fire_risk.client.ClientTenantFireRiskRepository
import com.fireavert.fire_risk.client.ClientTenantFireRiskRepositoryImpl
import com.fireavert.fire_risk.client.TenantFireRiskDataSource
import com.fireavert.fire_risk.client.TenantFireRiskDataSourceImpl
import com.fireavert.fire_risk.client.presentation.FireRiskScreen
import com.fireavert.fire_risk.client.presentation.RiskTableController
import com.fireavert.fire_risk.client.presentation.RiskTableInteractor
import com.fireavert.fire_risk.client.presentation.RiskTableViewModel
import com.fireavert.gateways.gateway_dialog.client.presentation.GatewayDialogController
import com.fireavert.gateways.gateway_dialog.client.presentation.GatewayDialogInteractor
import com.fireavert.gateways.gateway_dialog.client.presentation.GatewayDialogScreen
import com.fireavert.gateways.gateway_dialog.client.presentation.GatewayDialogViewModel
import com.fireavert.gateways.gateway_property_page.client.GatewayPropertyDataSource
import com.fireavert.gateways.gateway_property_page.client.GatewayPropertyDataSourceImpl
import com.fireavert.gateways.gateway_property_page.client.GatewayPropertyRepository
import com.fireavert.gateways.gateway_property_page.client.GatewayPropertyRepositoryImpl
import com.fireavert.gateways.gateway_property_page.client.presentation.GatewayPropertyController
import com.fireavert.gateways.gateway_property_page.client.presentation.GatewayPropertyInteractor
import com.fireavert.gateways.gateway_property_page.client.presentation.GatewayPropertyScreen
import com.fireavert.gateways.gateway_property_page.client.presentation.GatewayPropertyViewModel
import com.fireavert.info.client.presentation.*
import com.fireavert.invite.client.presentation.Invite
import com.fireavert.invite.client.presentation.InviteController
import com.fireavert.invite.client.presentation.InviteScreen
import com.fireavert.invite.client.presentation.InviteViewModel
import com.fireavert.jobs.client.ClientJobDataSource
import com.fireavert.jobs.client.ClientJobRepository
import com.fireavert.jobs.client.CommonClientJobDataSource
import com.fireavert.jobs.client.CommonClientJobRepository
import com.fireavert.logging.Logger
import com.fireavert.logging.NapierLogger
import com.fireavert.management_companies.client.ManagementCompanyDataSource
import com.fireavert.management_companies.client.ManagementCompanyDataSourceImpl
import com.fireavert.management_companies.client.ManagementCompanyRepository
import com.fireavert.management_companies.client.ManagementCompanyRepositoryImpl
import com.fireavert.management_companies.client.presentation.*
import com.fireavert.menu.client.ApiMenuNotificationRepository
import com.fireavert.menu.client.MenuDataSource
import com.fireavert.menu.client.RemoteMenuDataSource
import com.fireavert.menu.client.presentation.*
import com.fireavert.menu.menu_navigation.client.MenuNavigator
import com.fireavert.menu.menu_navigation.client.MenuRouter
import com.fireavert.menu.menu_navigation.client.RoutedMenuNavigator
import com.fireavert.properties.add_new_property.AddNewPropertyController
import com.fireavert.properties.add_new_property.client.presentation.AddNewPropertyViewModel
import com.fireavert.properties.comm_v2_conversion_dialog.CommV2ConversionDialogController
import com.fireavert.properties.comm_v2_conversion_dialog.CommV2ConversionDialogViewModel
import com.fireavert.properties.delete_property_admin_dialog.client.AddRemovePropertyAdminValidator
import com.fireavert.properties.delete_property_admin_dialog.client.presentation.*
import com.fireavert.properties.delete_property_dialog.DeletePropertyDialogController
import com.fireavert.properties.delete_property_dialog.DeletePropertyDialogViewModel
import com.fireavert.properties.edit_property.client.presentation.*
import com.fireavert.properties.logic.add_new_property.AddNewProperty
import com.fireavert.properties.logic.add_new_property.AddNewPropertyScreen
import com.fireavert.properties.logic.add_new_property.ClientAddNewProperty
import com.fireavert.properties.logic.comm_v3_conversion_dialog.CommV2Conversion
import com.fireavert.properties.logic.comm_v3_conversion_dialog.CommV2ConversionScreen
import com.fireavert.properties.logic.delete_property.ClientDeleteProperty
import com.fireavert.properties.logic.delete_property.DeleteProperty
import com.fireavert.properties.logic.delete_property.DeletePropertyDialogScreen
import com.fireavert.properties.property_details.client.presentation.*
import com.fireavert.properties.property_portfolio.client.presentation.*
import com.fireavert.properties.shared.client.*
import com.fireavert.react.pages.administration.breadcrumbs.google_analytics.GA4AnalyticsService
import com.fireavert.reboot.logic.Reboot
import com.fireavert.reboot.logic.RebootImpl
import com.fireavert.reboot.logic.RebootNavigator
import com.fireavert.reboot.logic.RebootScreen
import com.fireavert.reboot.presentation.RebootPageController
import com.fireavert.reboot.presentation.RebootRouter
import com.fireavert.reboot.presentation.RebootViewModel
import com.fireavert.reboot.presentation.RoutedRebootNavigator
import com.fireavert.reports_page.reports_data_export.client.presentation.ReportsExportDialogController
import com.fireavert.reports_page.reports_data_export.client.presentation.ReportsExportDialogInteractor
import com.fireavert.reports_page.reports_data_export.client.presentation.ReportsExportDialogScreen
import com.fireavert.reports_page.reports_data_export.client.presentation.ReportsExportDialogViewModel
import com.fireavert.reports_page.reports_page.client.ReportsPageRepository
import com.fireavert.reports_page.reports_page.client.ReportsPageRepositoryDataSource
import com.fireavert.reports_page.reports_page.client.ReportsPageRepositoryDataSourceImpl
import com.fireavert.reports_page.reports_page.client.ReportsPageSectionRepositoryImpl
import com.fireavert.reports_page.reports_page.client.presentation.ReportsPageScreen
import com.fireavert.reports_page.reports_page.client.presentation.ReportsPageSectionController
import com.fireavert.reports_page.reports_page.client.presentation.ReportsPageViewModel
import com.fireavert.reports_page.reports_page.client.presentation.ReportsPagesSectionInteractor
import com.fireavert.tenants.client.ApiTenantRepository
import com.fireavert.tenants.client.ClientTenantDataSource
import com.fireavert.tenants.client.ClientTenantRepository
import com.fireavert.tenants.client.TenantDataSource
import com.fireavert.tenants.server.UnitTenantService
import com.fireavert.topnav.client.presentation.*
import com.fireavert.units.add_new_unit_client.client.presentation.AddNewUnit
import com.fireavert.units.add_new_unit_client.client.presentation.AddNewUnitController
import com.fireavert.units.add_new_unit_client.client.presentation.ClientAddNewUnit
import com.fireavert.units.add_new_unit_csv.client.presentation.*
import com.fireavert.units.client.ApiUnitsRepository
import com.fireavert.units.client.ClientUnitsDataSource
import com.fireavert.units.client.UnitsDataSource
import com.fireavert.units.delete_unit.client.presentation.*
import com.fireavert.units.edit_unit.client.presentation.*
import com.fireavert.units.list_unit.client.presentation.*
import com.fireavert.units.shared.client.*
import com.fireavert.units.unit_detail_dialog.client.presentation.UnitDetails
import com.fireavert.units.unit_detail_dialog.client.presentation.UnitDetailsController
import com.fireavert.units.unit_detail_dialog.client.presentation.UnitDetailsScreen
import com.fireavert.units.unit_detail_dialog.client.presentation.UnitDetailsViewModel
import com.fireavert.unsubscribe.client.APIUnsubscribeDataSource
import com.fireavert.unsubscribe.client.ClientUnsubscribeSetter
import com.fireavert.unsubscribe.client.UnsubscribeSetterDataSource
import com.fireavert.unsubscribe.client.presentation.UnsubscribeController
import com.fireavert.unsubscribe.client.presentation.UnsubscribeViewModel
import com.fireavert.unsubscribe.sever.UnsubscribeSetter
import com.fireavert.user.UserRepository
import com.fireavert.user.client.*
import com.fireavert.user.data_models.TokenRefreshService
import com.fireavert.yardi.common_data.client.YardiCommonDataClientDataSource
import com.fireavert.yardi.common_data.client.YardiCommonDataClientDataSourceImpl
import com.fireavert.yardi.common_data.client.YardiCommonDataClientRepository
import com.fireavert.yardi.common_data.client.YardiCommonDataClientRepositoryImpl
import com.russhwolf.settings.JsSettings
import com.russhwolf.settings.Settings
import io.github.aakira.napier.DebugAntilog
import io.ktor.client.*
import io.ktor.client.engine.js.*
import io.ktor.client.plugins.contentnegotiation.*
import io.ktor.serialization.kotlinx.json.*
import kotlinx.browser.window
import kotlinx.coroutines.Dispatchers
import kotlinx.serialization.json.Json
import org.koin.core.qualifier.named
import org.koin.dsl.bind
import org.koin.dsl.binds
import org.koin.dsl.module

val host = window.location.host
val protocol = window.location.protocol

object KoinModules {

    private val apiBaseUrl = "$protocol//$host/api"
    private val logging = module {
        single { NapierLogger(DebugAntilog()) } bind Logger::class
    }
    private val infoPageModule = module {
        single {
            InfoPageViewModel()
        } bind InfoPageScreen::class

        factory {
            InfoPageImpl(deviceRepository = get(), screen = get(), logger = get())
        } bind InfoPage::class

        factory {
            InfoPageController(interactor = get())
        }
    }
    private val rebootModule = module {
        single {
            RebootViewModel()
        } bind RebootScreen::class

        single {
            RoutedRebootNavigator(
                rebootRouter = get()
            )
        } bind RebootNavigator::class

        factory {
            RebootImpl(
                screen = get(),
                devicesRepository = get(),
                logger = get(),
                rebootNavigator = get()
            )
        } bind Reboot::class

        factory {
            RebootPageController(reboot = get())
        }
    }
    private val unitsModule = module {

        single {
            UnitDetailsViewModel()
        } bind UnitDetailsScreen::class
        factory {
            ClientDeleteUnit(
                unitsNavigator = get(),
                screen = get(),
                unitsRepository = get(),
                logger = get()
            )
        } bind DeleteUnit::class
        single {
            DeleteUnitDialogViewModel()
        } bind DeleteUnitDialogScreen::class
        factory {
            DeleteUnitDialogController(
                interactor = get()
            )
        }
        factory {
            ClientUnitDetails(
                screen = get(),
                navigator = get(),
                unitsRepository = get(),
                deviceRepository = get(),
                eventsRepository = get(),
                tenantRepository = get(),
                propertyRepository = get(),
                logger = get()
            )
        } bind UnitDetails::class
        factory {
            UnitDetailsController(
                interactor = get(),
                screen = get()
            )
        }
        single(named("add")) {
            AddOrEditUnitViewModel()
        } bind AddOrEditUnitScreen::class
        single(named("edit")) {
            AddOrEditUnitViewModel()
        } bind AddOrEditUnitScreen::class

        factory {
            ClientAddNewUnit(
                unitsNavigator = get(),
                screen = get(qualifier = named("add")),
                propertyRepository = get(),
                unitsRepository = get(),
                deviceRepository = get(),
                logger = get()
            )
        } bind AddNewUnit::class

        factory {
            ClientEditUnit(
                unitsNavigator = get(),
                screen = get(qualifier = named("edit")),
                unitsRepository = get(),
                deviceRepository = get(),
                propertyRepository = get(),
                logger = get()
            )
        } bind EditUnit::class

        factory(named("addDevice")) {
            AddEditDeviceImpl(screen = get(qualifier = named("add")))
        } bind AddEditDevice::class
        factory(named("editDevice")) {
            AddEditDeviceImpl(screen = get(qualifier = named("edit")))
        } bind AddEditDevice::class

        factory {
            EditUnitDialogController(editUnitInteractor = get(), addEditDevice = get(qualifier = named("editDevice")))
        }

        factory {
            AddNewUnitController(addNewUnit = get(), addEditDevice = get(qualifier = named("addDevice")))
        }

        single {
            AddNewUnitsCSVDialogViewModel()
        } bind AddNewUnitCSVScreen::class

        factory {
            ClientAddNewUnitCSV(
                screen = get(),
                unitsRepository = get(),
                deviceRepository = get(),
                unitsNavigator = get(),
                jobsRepository = get(),
                logger = get()
            )
        } bind AddNewUnitCSV::class

        factory {
            AddNewUnitsCSVDialogController(addNewUnitCSV = get())
        }
        factory {
            UnitsSectionController(
                interactor = get()
            )
        }
        factory {
            ClientUnitsInteractor(
                screen = get(),
                preferences = get(),
                unitsRepository = get(),
                unitsNavigator = get(),
                activeEventsRepository = get(),
                tenantFireRiskRepository = get(),
                logger = get()
            )
        } bind UnitsInteractor::class

        single {
            RoutedUnitsNavigator(unitsRouter = get())
        } bind UnitsNavigator::class

        single {
            UnitsSectionViewModel()
        } bind UnitsSectionScreen::class

        single {
            ApiUnitsRepository(
                dataSource = get(),
                ioContext = Dispatchers.Default,
                tokenRefreshService = get(),
                preferences = get(),
                logger = get()
            )
        } bind UnitsRepository::class

        single {
            ClientUnitsDataSource(
                httpClient = get(), baseUrl = apiBaseUrl
            )
        } bind UnitsDataSource::class
    }
    private val eventsModule = module {

        single {
            ActiveEventsV2ViewModel()
        } bind ActiveEventsV2Screen::class

        factory {
            ActiveEventsV2Interactor(
                activeEventsV2Screen = get(),
                activeEventsRepository = get(),
                logger = get()
            )
        }
        factory { RebootDeviceDialogController(interactor = get()) }
        factory {
            ClientRebootDevice(
                deviceRepository = get(),
                screen = get(),
                eventsNavigator = get(),
                logger = get()
            )
        } bind RebootDevice::class
        single {
            RebootDeviceDialogViewModel()
        } bind RebootDeviceDialogScreen::class

        factory { MarkAsTestDialogController(interactor = get()) }
        factory {
            ClientMarkAsTest(
                eventsRepository = get(), screen = get(), eventsNavigator = get()
            )
        } bind MarkAsTest::class
        single {
            MarkAsTestDialogViewModel()
        } bind MarkAsTestDialogScreen::class

        factory {
            MarkAsFalseAlarmController(
                onLoadUseCase = get(),
                navigator = get(),
                screen = get(),
                ioContext = Dispatchers.Default
            )
        }
        /**
         * Mark As False Alarm
         */
        factory {
            OnLoadUseCaseImpl(eventsRepository = get())
        } bind OnLoadUseCase::class
        single {
            MarkAsFalseAlarmViewModel()
        } bind Screen::class


        factory { DismissEventDialogController(interactor = get()) }
        factory {
            ClientDismissEvent(
                eventsRepository = get(), screen = get(), eventsNavigator = get()
            )
        } bind DismissEvent::class
        single {
            ApiEventsRepository(
                dataSource = get(),
                tokenRefreshService = get(),
                preferences = get(),
                ioContext = Dispatchers.Default
            )
        } bind EventsRepository::class
        single {
            ClientEventsDataSource(httpClient = get(), baseUrl = apiBaseUrl, logger = get())
        } bind EventsDataSource::class
        single {
            DismissEventDialogViewModel()
        } bind DismissEventDialogScreen::class
        single { RoutedEventsNavigator(eventsRouter = get()) } bind EventsNavigator::class

        single {
            ClientActiveEventsDataSource(
                httpClient = get(),
                baseUrl = apiBaseUrl
            )
        } bind ActiveEventsDataSource::class

        single {
            ApiActiveEventsRepository(
                ioContext = Dispatchers.Default,
                tokenRefreshService = get(),
                preferences = get(),
                activeEventsDataSource = get()
            )
        } bind ActiveEventsRepository::class

        factory {
            ActiveDeviceEventsController(
                interactor = get()
            )
        }
        factory {
            ClientActiveDeviceEvents(
                deviceRepository = get(),
                unitsRepository = get(),
                activeEventsRepository = get(),
                screen = get(),
                logger = get()
            )
        } bind ActiveDeviceEvents::class
        single { ActiveDeviceEventsViewModel() } bind ActiveDeviceEventsScreen::class
    }
    private val devicesModule = module {
        single {
            ClientDeviceDataSource(
                httpClient = get(), baseUrl = apiBaseUrl, logger = get()
            )
        } bind DeviceDataSource::class
        single {
            ApiDeviceRepository(
                dataSource = get(),
                tokenRefreshService = get(),
                preferences = get(),
                ioContext = Dispatchers.Default,
                logger = get()
            )
        } bind DeviceRepository::class
    }
    private val propertyModule = module {

        single {
            CommV2ConversionDialogViewModel()
        } bind CommV2ConversionScreen::class

        factory {
            CommV2Conversion(propertyNavigator = get(),
                deviceRepository = get(),
                screen = get(),
                logger = get()
            )
        }
        factory {
            CommV2ConversionDialogController(useCase = get())
        }
        factory {
            DeletePropertyDialogController(interactor = get())
        }
        factory {
            ClientDeleteProperty(
                propertyNavigator = get(),
                screen = get(),
                propertyRepository = get(),
                logger = get()
            )
        } bind DeleteProperty::class
        single {
            DeletePropertyDialogViewModel()
        } bind DeletePropertyDialogScreen::class

        single { EditPropertyViewModel() } bind EditPropertyScreen::class
        factory {
            ClientEditProperty(
                screen = get(),
                propertyNavigator = get(),
                propertyRepository = get(),
                logger = get(),
            )
        } bind EditProperty::class
        factory {
            EditPropertyController(editProperty = get())
        }

        single { PropertyDetailsViewModel() } bind PropertyDetailsScreen::class
        factory {
            ClientPropertyDetails(
                propertyRepository = get(),
                screen = get(),
                clientUserRepository = get(),
                clientTenantFireRiskRepository = get(),
                logger = get(),
            )
        } bind PropertyDetails::class
        factory { PropertyDetailsController(propertyDetails = get()) }

        single {
            ClientPropertyDataSource(
                httpClient = get(),
                baseUrl = apiBaseUrl
            )
        } bind PropertyDataSource::class
        single {
            ApiPropertyRepository(
                ioContext = Dispatchers.Default,
                tokenRefreshService = get(),
                dataSource = get(),
                preferences = get(),
                inMemoryCache = get(),
                logger = get()
            )
        } bind ClientPropertyRepository::class
        single { RoutedPropertyNavigator(get()) } bind PropertyNavigator::class
        single { PropertyPortfolioViewModel() } bind PropertyPortfolioScreen::class
        factory {
            ClientPropertyPortfolio(
                propertyRepository = get(), screen = get(), logger = get(), preferences = get()
            )
        } bind PropertyPortfolio::class
        factory {
            PropertyPortfolioController(
                propertyNavigator = get(),
                propertyPortfolio = get()
            )
        }
        factory { AddNewPropertyController(addNewProperty = get()) }
        factory {
            ClientAddNewProperty(
                screen = get(),
                propertyNavigator = get(),
                propertyRepository = get(),
                logger = get()
            )
        } bind AddNewProperty::class
        single { AddNewPropertyViewModel(
            logger = get()
        ) } bind AddNewPropertyScreen::class

        factory {
            GatewayPropertyDataSourceImpl(httpClient = get(), baseUrl = apiBaseUrl)
        } bind GatewayPropertyDataSource::class

        factory {
            GatewayPropertyRepositoryImpl(
                dataSource = get(),
                preferences = get(),
                ioContext = Dispatchers.Default,
                tokenRefreshService = get()
            )
        } bind GatewayPropertyRepository::class

        factory {
            GatewayPropertyInteractor(repository = get(), screen = get())
        }

        factory {
            GatewayDialogInteractor(repository = get(), screen = get(), gatewayPropertyScreen = get())
        }

        factory {
            GatewayPropertyController(interactor = get())
        }

        factory {
            GatewayDialogController(interactor = get())
        }

        single { GatewayPropertyViewModel() } bind GatewayPropertyScreen::class

        single {GatewayDialogViewModel() } bind GatewayDialogScreen::class
    }



    private val httpClientModule = module {
        single {
            HttpClient(Js) {
                install(ContentNegotiation) {
                    json(Json {
                        prettyPrint = true
                        isLenient = true
                    })
                }
            }
        }
    }

    private val userModule = module {
        single {
            ClientUserDataSource(
                httpClient = get(), baseUrl = apiBaseUrl, logger = get()
            )
        } bind UserDataSource::class
        single { InMemoryUserDataCache() } bind UserDataCache::class
        single {
            ClientUserRepository(
                dataCache = get(), dataSource = get(), Dispatchers.Default, preferences = get()
            )
        } bind UserRepository::class
        factory {
            GetUser(
                userRepository = get(),
                preferences = get(),
                tokenRefreshService = get()
            )
        }
    }

    private val preferencesModule = module {
        single { KeyValuePreferences(settings = get(), logger = get()) } bind Preferences::class
        single { JsSettings() } bind Settings::class
    }

    private val authModule = module {
        single { AuthViewModel() } bind AuthScreen::class
        single { RoutedAuthNavigator(authRouter = get()) } bind AuthNavigator::class
        single { NavRouter() } binds arrayOf(
            AuthRouter::class,
            MenuRouter::class,
            PropertyRouter::class,
            DevicesRouter::class,
            EventsRouter::class,
            UnitsRouter::class,
            AdminRouter::class,
            RebootRouter::class,
        )
        single {
            UserPreferencesTokenRefreshService(
                userRepository = get(),
                preferences = get(),
                logger = get()
            )
        } bind TokenRefreshService::class

        factory {
            ClientUserAuthenticator(
                userRepository = get(),
                authScreen = get(),
                authNavigator = get(),
                preferences = get(),
                analyticsService = get(),
                inMemoryCache = get(),
                logger = get()
            )
        } bind UserAuthenticator::class

        factory {
            ClientPageAuthenticator(
                userRepository = get(),
                preferences = get(),
            )
        } bind PageAuthenticator::class
        factory { AuthController(get()) }
        factory { PageAuthenticationController(get()) }
    }

    private val unsubscribeModule = module {
        single {
            APIUnsubscribeDataSource(httpClient = get(), logger = get(), baseUrl = apiBaseUrl)
        } bind UnsubscribeSetterDataSource::class
        single {
            ClientUnsubscribeSetter(ioContext = Dispatchers.Default, dataSource = get())
        } bind UnsubscribeSetter::class
        factory {
            UnsubscribeController(unsubscribeSetter = get())
        }
        single {
            UnsubscribeViewModel()
        }
    }
    private val inMemoryCacheModule = module {
        single {
            InMemoryCache()
        }
    }

    private val addRemovePropertyAdminRowModule = module {
        factory {
            AddRemovePropertyAdminRowController(
                validator = get()
            )
        }
        factory {
            AddRemovePropertyAdminValidator()
        }
    }

    private val addRemoveDeviceContainerModule = module {
        factory {
            AddRemoveDevicesContainerController(preferences = get())
        }
        factory {
            AddRemoveDeviceRowController()
        }
    }

    private val deletePropertyAdminModule = module {
        factory {
            ClientDeletePropertyAdmin(
                propertyRepository = get(),
                screen = get(),
                logger = get(),
            )
        } bind DeletePropertyAdmin::class

        factory {
            DeletePropertyAdminDialogController(
                propertyNavigator = get(),
                deletePropertyAdmin = get()
            )
        }

        single {
            DeletePropertyAdminDialogViewModel()
        } bind DeletePropertyAdminDialogScreen::class
    }

    private val navigationModule = module {
        single { TopNavViewModel() } bind TopNavScreen::class
        factory {
            ClientTopNav(
                screen = get(),
                preferences = get(),
                authNavigator = get(),
                adminNavigator = get(),
                getUser = get(),
                logger = get()
            )
        } bind TopNav::class
        factory { TopNavController(topNav = get(), userAuthenticator = get()) }
        single { RoutedMenuNavigator(router = get()) } bind MenuNavigator::class
        single { MenuViewModel() } bind MenuScreen::class
        factory {
            MenuInteractor(
                logger = get(),
                screen = get(),
                preferences = get(),
                menuNotificationRepository = get(),
                propertyRepository = get(),
                globalFilterController = get(),
                propertyNavigator = get(),
            )
        }
        factory { MenuController(navigator = get(), interactor = get()) }
        single {
            ApiMenuNotificationRepository(
                dataSource = get(),
                ioContext = Dispatchers.Default,
                tokenRefreshService = get(),
                preferences = get()
            )
        } bind MenuNotificationRepository::class
        single {
            RemoteMenuDataSource(httpClient = get(), baseUrl = apiBaseUrl, logger = get())
        } bind MenuDataSource::class

        single {
            GlobalFilterController(
                dashboardController = get(),
                reportsController = get(),
                fireRiskController = get(),
            )
        }
    }

    private val inviteModule = module {
        single {
            InviteViewModel()
        } bind InviteScreen::class
        factory {
            InviteController(invite = get())
        }
        factory {
            Invite(screen = get(), authenticator = get(), userRepository = get(), logger = get())
        }
    }

    private val jobsModule = module {
        single {
            CommonClientJobDataSource(
                httpClient = get(),
                baseUrl = apiBaseUrl
            )
        } bind ClientJobDataSource::class

        single {
            CommonClientJobRepository(
                ioContext = Dispatchers.Default,
                tokenRefreshService = get(),
                jobDataSource = get(),
                preferences = get()
            )
        } bind ClientJobRepository::class
    }

    private val resetPasswordModule = module {
        single {
            ResetPasswordViewModel()
        } bind ResetPasswordScreen::class
        single {
            HttpPasswordSenderSource(baseUrl = apiBaseUrl, httpClient = get())
        } bind ResetPasswordSenderSource::class
        single {
            ResetPasswordSenderImpl(
                resetPasswordSenderSource = get(),
                ioContext = Dispatchers.Default,
                logger = get(),
            )
        } bind ResetPasswordSender::class
        factory {
            ResetPasswordUseCase(screen = get(), authNavigator = get(), resetPasswordSender = get())
        }
        factory {
            ResetPasswordController(useCase = get())
        }
    }

    private val scrollPageManagerModule = module {
        single {
            window
        }
        single(qualifier = named("screenScrollData")) {
            mutableMapOf<String, Pair<Double, Double>>()
        }
    }

    private val reportsPageModule = module {
        single {
            ReportsPageRepositoryDataSourceImpl(
                baseUrl = apiBaseUrl,
                httpClient = get()
            )
        } bind ReportsPageRepositoryDataSource::class

        single {
            ReportsPageSectionRepositoryImpl(
                dataSource = get(),
                preferences = get(),
                ioContext = Dispatchers.Default,
                tokenRefreshService = get()
            )
        } bind ReportsPageRepository::class

        single {
            ReportsPageViewModel()
        } bind ReportsPageScreen::class

        factory {
            ReportsPagesSectionInteractor(
                screen = get(),
                propertyRepository = get(),
                reportsPageRepository = get(),
                logger = get()
            )
        }

        factory {
            ReportsPageSectionController(
                interactor = get()
            )
        }

        factory {
            ReportsExportDialogController(
                interactor = get()
            )
        }

        factory {
            ReportsExportDialogInteractor(
                screen = get(),
                reportsPageRepository = get(),
                logger = get()
            )
        }

        single {
            ReportsExportDialogViewModel()
        } bind ReportsExportDialogScreen::class

    }

    private val managementCompanyModule = module {
        single {
            ManagementCompanyDataSourceImpl(
                baseUrl = apiBaseUrl,
                httpClient = get()
            )
        } bind ManagementCompanyDataSource::class

        single {
            ManagementCompanyRepositoryImpl(
                dataSource = get(),
                preferences = get(),
                ioContext = Dispatchers.Default,
                tokenRefreshService = get()
            )
        } bind ManagementCompanyRepository::class


        factory { ManagementCompanyController(interactor = get()) }

        single { ManagementCompaniesViewModel() } bind ManagementCompanyScreen::class

        factory { ManagementCompanyInteractor(
            screen = get(),
            repository = get(),
            pageScreen = get(),
            propertyRepository = get(),
            inMemoryCache = get(),
            preferences = get(),
        ) }

        single { ManagementCompaniesPageViewModel() } bind ManagementCompanyPageScreen::class
        factory { ManagementCompanyController(interactor = get()) }
    }

    private val buildingModule = module {
        single {
            ClientBuildingRepositoryDataSourceImpl(baseUrl = apiBaseUrl, httpClient = get())
        } bind ClientBuildingRepositoryDataSource::class

        single {
            ClientBuildingRepositoryImpl(
                dataSource = get(),
                preferences = get(),
                ioContext = Dispatchers.Default,
                tokenRefreshService = get()
            )
        } bind ClientBuildingRepository::class

        factory {
            AddNewBuildingInteractor(
                clientBuildingRepository = get(),
                screen = get(),
            )
        }

        factory { AddNewBuildingController(interactor = get()) }

        single {
            AddNewBuildingViewModel()
        } bind AddNewBuildingScreen::class
    }

    private val userTrackingModule = module {

        single {
            UserSectionRepositoryDataSourceImpl(baseUrl = apiBaseUrl, httpClient = get())
        } bind UserSectionRepositoryDataSource::class

        single {
            UserSectionRepositoryImpl(
                dataSource = get(),
                preferences = get(),
                ioContext = Dispatchers.Default,
                tokenRefreshService = get()
            )
        } bind UserSectionRepository::class

        single {
            UserSectionViewModel()
        } bind UserSectionScreen::class

        factory {
            UserSectionInteractor(
                screen = get(),
                userSectionRepository = get(),
                logger = get()
            )
        }
        factory { UserSectionController(interactor = get()) }

    }

    private val administrationPageModule = module {

        factory { AdministrationPageController(interactor = get()) }

        single {
            RoutedAdminNavigator(adminRouter = get())
        } bind AdminNavigator::class

        single {
            AdministrationPageViewModel()
        } bind AdministrationPageScreen::class

        single {AdminPageRepositoryDataSourceImpl(
            baseUrl = apiBaseUrl, httpClient = get())
        } bind AdminPageRepositoryDataSource::class

        single {
            AdministrationPageRepositoryImpl(
                datasource = get(),
                preferences = get(),
                ioContext = Dispatchers.Default,
                tokenRefreshService = get()
            )
        } bind AdministrationPageRepository::class
        factory {
            AdministrationPageInteractor(
                screen = get(),
                adminPageRepository = get(),
                propertyRepository = get(),
            )
        }
    }

    private val userAdminModule = module {

        single {
            UserInfoRepositoryDataSourceImpl(baseUrl = apiBaseUrl, httpClient = get())
        } bind UserInfoRepositoryDataSource::class

        single {
            UserInfoRepositoryImpl(
                dataSource = get(),
                preferences = get(),
                ioContext = Dispatchers.Default,
                tokenRefreshService = get()
            )
        } bind UserInfoRepository::class

        single {
            UserInfoViewModel()
        } bind UserInfoScreen::class

        factory {
            UserInfoInteractor(
                screen = get(),
                userInfoRepository = get(),
                propertyRepository = get(),
                logger = get()
            )
        }

        factory { UserInfoController(interactor = get()) }

        single {
            UserDialogRepositoryDataSourceImpl(baseUrl = apiBaseUrl, httpClient = get())
        } bind UserDialogRepositoryDataSource::class

        single {
            UserDialogRepositoryImpl(
                dataSource = get(),
                preferences = get(),
                ioContext = Dispatchers.Default,
                tokenRefreshService = get()
            )
        } bind UserDialogRepository::class

        single {
            AddUserViewModel()
        } bind AddUserDialogScreen::class

        factory {
            AddUserController(
                interactor = get()
            )
        }

        factory {
            AddUserInteractor(
                screen = get(),
                userDialogRepository = get(),
                userInfoRepository = get(),
                propertyRepository = get(),
                logger = get()
            )
        }
    }

    private val wirelessIdModule = module {
        single {
            WirelessIdRepositoryDataSourceImpl(
                baseUrl = apiBaseUrl,
                httpClient = get(),
                logger = get()
            )
        } bind WirelessIdRepositoryDataSource::class

        single {
            WirelessIdRepositoryImpl(
                dataSource = get(),
                preferences = get(),
                ioContext = Dispatchers.Default,
                tokenRefreshService = get()
            )
        } bind WirelessIdRepository::class

        single {
            WirelessIdSectionViewModel()
        } bind WirelessIdSectionScreen::class

        factory {
            WirelessIdSectionInteractor(
                inMemoryCache = get(),
                screen = get(),
                wirelessIdRepository = get(),
                userRepository = get(),
                propertyRepository = get(),
                logger = get()
            )
        }
        factory { WirelessIdSectionController(interactor = get()) }
    }

    private val applicationModule = module {
        single {
            ClientAnalyticsDataSourceImpl(
                baseUrl = apiBaseUrl,
                httpClient = get()
            )
        } bind ClientAnalyticsDataSource::class
        single {
            ClientAnalyticsRepositoryImpl(
                clientAnalyticsDataSource = get(),
                preferences = get(),
                logger = get(),
                ioContext = Dispatchers.Default,
                tokenRefreshService = get()
            )
        } bind ClientAnalyticsRepository::class

        single {
            AppViewModel()
        }
        factory { AnalyticsUseCase(clientAnalyticsRepository = get()) }
        factory {
            AppController(analyticsUseCase = get())
        }
    }

    private val dashboardModule = module {
        single {
            ClientDashboardRepositoryDataSource(
                baseUrl = apiBaseUrl,
                httpClient = get(),
                logger = get()
            )
        } bind DashboardRepositoryDataSource::class

        single {
            ApiDashboardRepository(
                ioContext = Dispatchers.Default,
                tokenRefreshService = get(),
                preferences = get(),
                dataSource = get(),
                logger = get()
            )
        } bind DashboardRepository::class

        single {
            DashboardViewModel()
        } bind DashboardScreen::class

        factory {
            DashboardInteractor(
                screen = get(),
                dashboardRepository = get(),
                activeEventsV2Screen = get(),
                activeEventsRepository = get(),
                preferences = get(),
                logger = get()
            )
        }
        factory {
            DashboardController(
                interactor = get()
            )
        }
    }

    private val yardiModule = module {

        factory { YardiCommonDataController(interactor = get()) }

        factory { YardiCommonDataInteractor(
            repository = get(),
            managementCompanyRepository = get(),
            screen = get()
        ) }

        factory {
            YardiCommonDataClientRepositoryImpl(
                dataSource = get(),
                preferences = get(),
                ioContext = Dispatchers.Default,
                tokenRefreshService = get(),
            )
        } bind YardiCommonDataClientRepository::class

        factory {
            YardiCommonDataClientDataSourceImpl(
                baseUrl = apiBaseUrl,
                httpClient = get()
            )
        } bind YardiCommonDataClientDataSource::class

        single {
            YardiCommonDataViewModel()
        } bind YardiCommonDataScreen::class

        single {
            YardiPropertyImportViewModel()
        } bind YardiPropertyImportScreen::class

        factory {
            YardiPropertyImportController(
                interactor = get()
            )
        }

        factory {
            YardiPropertyImportInteractorImpl(
                propertyRepository = get(), yardiRepository = get(), unitsRepository = get(), viewModel = get())
        } bind YardiPropertyImportInteractor::class
    }

    private val fireRiskModule = module {
        single {
            TenantFireRiskDataSourceImpl(
                baseUrl = apiBaseUrl,
                httpClient = get(),
                logger = get()
            )
        } bind TenantFireRiskDataSource::class
        single {
            ClientTenantFireRiskRepositoryImpl(
                dataSource = get(),
                keyValuePreferences = get(),
                ioContext = Dispatchers.Default,
                tokenRefreshService = get(),
                logger = get()
            )
        } bind ClientTenantFireRiskRepository::class
        factory {
            RiskTableController(interactor = get())
        }
        factory {
            RiskTableInteractor(
                screen = get(),
                propertyRepository = get(),
                reportsPageRepository = get(),
                logger = get(),
                clientTenantFireRiskRepository = get(),
                preferences = get(),
            )
        }
        single {
            RiskTableViewModel()
        } bind FireRiskScreen::class
    }

    private val tenantModule = module {
        single {
            ClientTenantDataSource(
                httpClient = get(),
                baseUrl = apiBaseUrl,
                logger = get()
            )
        } bind TenantDataSource::class

        single {
            ApiTenantRepository(
                ioContext = Dispatchers.Default,
                tokenRefreshService = get(),
                dataSource = get(),
                preferences = get(),
                logger = get()
            )
        } bind ClientTenantRepository::class

        factory {
            UnitTenantService(
                tenantRepository = get(),
            )
        }
    }

    private val ga4Model = module {
        single { GA4AnalyticsService() } bind AnalyticsService::class
    }

    val all = listOf(
        inMemoryCacheModule,
        logging,
        httpClientModule,
        userModule,
        preferencesModule,
        authModule,
        navigationModule,
        propertyModule,
        devicesModule,
        eventsModule,
        unitsModule,
        rebootModule,
        infoPageModule,
        unsubscribeModule,
        addRemovePropertyAdminRowModule,
        addRemoveDeviceContainerModule,
        deletePropertyAdminModule,
        inviteModule,
        jobsModule,
        resetPasswordModule,
        scrollPageManagerModule,
        userTrackingModule,
        applicationModule,
        dashboardModule,
        reportsPageModule,
        wirelessIdModule,
        buildingModule,
        administrationPageModule,
        userAdminModule,
        managementCompanyModule,
        ga4Model,
        yardiModule,
        fireRiskModule,
        tenantModule,
    )
}